import { SERVICEURI } from "../const/serviceuri";
import { deletePartApiInstance, getPartApiInstance, postFormPartApiInstance, postPartApiInstance } from '../instance/fetchpartapiInstance';
import { getFrameworkApiInstance } from '../instance/fetchframeworkapiInstance';

const getBranchList = (distributor4Code: string, customerId: any, locationId: any): Promise<any> => {
    let endPoint = SERVICEURI.GetBranchList.replace("{distributor4Code}", distributor4Code)
        .replace("{customerId}", customerId).replace("{locationId}", locationId);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getManufactureList = (distributor4Code: string, branchCode: string): Promise<any> => {
    let endPoint = SERVICEURI.GetManufactureList.replace("{distributor4Code}", distributor4Code).replace("{branchCode}", branchCode);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getMachineListForShoppingCart = (data: any): Promise<any> => {
    let endPoint = SERVICEURI.GetMachineListForShoppingCart;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getPartsList = (userAddId: any, punchOutRequestPartLogId: any): Promise<any> => {
    let endPoint = SERVICEURI.GetPartsList?.replace("{userId}", userAddId)?.replace("{punchoutOrderRequestId}", punchOutRequestPartLogId);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getRefreshPartsList = (data: any, isHardRefresh: boolean = false): Promise<any> => {
    let endPoint = SERVICEURI.GetRefreshPartsList?.replace("{isHardRefresh}", isHardRefresh.toString());
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getMaintenancePartsList = (data: any): Promise<any> => {
    let endPoint = SERVICEURI.GetMaintenancePartsList;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const addPartNumber = (data: any) => {
    let endPoint = SERVICEURI.AddPartNumber;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const addToCartQuote = (data: any) => {
    let endPoint = SERVICEURI.AddToCartQuote;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const deletePartNumbers = (data: any) => {
    let endPoint = SERVICEURI.DeletePartNumbers;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const deleteMiningPartNumbers = (data: any) => {
    let endPoint = SERVICEURI.DeleteMiningPartNumbers;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const updateCartItem = (data: any) => {
    let endPoint = SERVICEURI.UpdateCartItem;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getProductRecommendationByCartId = (cartId: any): Promise<any> => {
    let endPoint = SERVICEURI.GetProductRecommendationByCartId?.replace("{cartId}", cartId);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getProductRecommendationByPartNumber = (partNumber: any, userId: any, model: any, serial: any): Promise<any> => {
    let endPoint = SERVICEURI.GetProductRecommendationByPartNumber?.replace("{partNumber}", partNumber)?.replace("{userAadId}", userId);
    if (model && model.trim() != '') {
        endPoint = endPoint + '&model=' + model;
    }
    if (serial && serial.trim() != '') {
        endPoint = endPoint + '&serialNumber=' + serial
    }
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getBookmarkList = (userId: any) => {
    let endPoint = SERVICEURI.GetBookmarkList?.replace("{userAadId}", userId);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getSavedPartList = (data: any) => {
    let endPoint = SERVICEURI.GetSavedPartList;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getSavedPartListDetails = (data: any) => {
    let endPoint = SERVICEURI.GetSavedPartListDetails;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const saveBookmark = (data: any) => {
    let endPoint = SERVICEURI.SaveBookmark;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const removeBookmark = (data: any) => {
    let endPoint = SERVICEURI.RemoveBookmark;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const deleteItemFromPartList = (id: any) => {
    let endPoint = SERVICEURI.DeleteItemFromPartList?.replace("{savedshoppinglistid}", id);
    return new Promise((resolve, reject) => {
        deletePartApiInstance(endPoint, {})
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const exportToExcelSavedPartList = (data: any) => {
    let endPoint = SERVICEURI.ExportToExcelSavedPartList;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const savePartListDataWithBookmarkItem = (data: any) => {
    let endPoint = SERVICEURI.SavePartListDataWithBookmarkItem;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const applyPromoCode = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        let endPoint = SERVICEURI.ApplyPromoCode;
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const getItemSummaryDetails = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data;
        const endPoint = SERVICEURI.GetItemSummaryDetails?.replace("{cartId}", `${cartId}`).replace("{userAadId}", userAadId);
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const deletePromoCode = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.DeletePromoCode;
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const applyPartsCredit = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        let endPoint = SERVICEURI.ApplyPartsCredit;
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}


const clearPartsCredit = (cartId: any, userAadId: any) => {
    let endPoint = SERVICEURI.ClearPartsCredit.replace("{cartId}", cartId).replace("{userAadId}", userAadId);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}


const getAvailablePartsCredits = async (customerId: number): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.GetAvailablePartsCredits?.replace("{customerId}", `${customerId}`);
        const response = await getPartApiInstance(endPoint);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const getCustomerCreditInfo = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { customerId, cartId, userAadId } = data;
        const endPoint = SERVICEURI.GetCustomerCreditInfo?.replace("{customerId}", `${customerId}`)?.replace("{cartId}", `${cartId}`)?.replace("{userAadId}", `${userAadId}`);
        const response = await getPartApiInstance(endPoint);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const getQuoteList = (data: any) => {
    let endPoint = SERVICEURI.GetQuoteList;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const savePartListForQuote = (data: any) => {
    let endPoint = SERVICEURI.SavePartListForQuote;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const deleteOrArchiveQuote = async (data: any) => {
    let endPoint = SERVICEURI.DeleteOrArchiveQuote;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const shareQuote = (data: any) => {
    let endPoint = SERVICEURI.ShareQuote;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const shareCart = (file: any, sharedQuoteData: any) => {
    let endPoint = SERVICEURI.ShareCart;
    let formData = new FormData();
    if (file) {
        formData.append("File", file, file?.name);
    }
    formData.append("ShareQuoteData", sharedQuoteData);
    formData.append("Endpoint", endPoint);
    return new Promise((resolve, reject) => {
        postFormPartApiInstance(formData, true)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const uploadParts = (files: any) => {
    let endPoint = SERVICEURI.UploadParts;
    let formData = new FormData();
    for (let file of files) {
        formData.append("Files", file.getRawFile(), file?.name);
    }
    formData.append("Endpoint", endPoint);
    return new Promise((resolve, reject) => {
        postFormPartApiInstance(formData, false)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getQuotesDetailData = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.GetQuotesDetailData;
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const continuePartsCredit = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        let endPoint = SERVICEURI.ContinuePartsCredit;
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const saveCart = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        let endPoint = SERVICEURI.saveCart;
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const getFulfillmenPermissionDetails = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data;
        const endPoint = SERVICEURI.GetFulfillmenPermissionDetails?.replace("{cartId}", `${cartId}`).replace("{userAadId}", userAadId);
        const response = await getPartApiInstance(endPoint);

        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const getAvailabilityDetails = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data ?? {}
        const endPoint = SERVICEURI.GetAvailabilityDetails?.replace('{cartId}', cartId).replace('{userAadId}', userAadId);
        const response = await getPartApiInstance(endPoint);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const getFullfilmentBranchInfo = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data

        const endPoint = SERVICEURI.GetFullfilmentBranchInfo?.replace("{cartId}", `${cartId}`).replace("{userAadId}", userAadId);
        const response = await getPartApiInstance(endPoint);

        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const savePickupFulfillment = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.SavePickupFulfillment;
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const saveCartList = (data: any) => {
    let endPoint = SERVICEURI.SaveCartList;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getQuoteShareDetailData = (quoteId: any, currentUserEmail: any) => {
    let endPoint = SERVICEURI.GetQuoteShareDetailData?.replace("{quoteId}", quoteId)?.replace("{currentUserEmail}", currentUserEmail);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getWeatherWarning = async (cartId: any, userAadId:any, zipcode: any = '', countryCode: any = ''): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.GetWeatherWarning?.replace("{cartId}", cartId)?.replace("{userAadId}", userAadId)?.replace("{zipcode}", zipcode).replace("{countryCode}", countryCode);
        const response = await getPartApiInstance(endPoint);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const getShippingMethods = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data;
        let endPoint = SERVICEURI.GetShippingMethods?.replace("{cartId}", cartId)?.replace("{userAadId}", userAadId);
        const response = await getPartApiInstance(endPoint);

        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    }
    catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const getShippingCarriers = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        let endPoint = SERVICEURI.GetShippingCarriers;
        const response = await postPartApiInstance(endPoint, data);
        if (response) {
            return {
                isSuccess: true,
                msg: 'Success',
                data: response ?? {}
            };
        } else {
            return {
                isSuccess: false,
                msg: 'Failed',
                data: {}
            };
        }
    }
    catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}


const saveShipmentDetails = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { userAadId, reqBody } = data;
        const endPoint = SERVICEURI.SaveShipmentDetails.replace('{userAadId}', userAadId);
        const response = await postPartApiInstance(endPoint, reqBody);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const savePaymentDetails = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.SavePaymentDetails;
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? {}
        };
    }
    catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const saveCreditCard = (data: any) => {
    const endPoint = SERVICEURI.SaveCreditCard;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getSavedAddressList = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.GetSavedAddressList;
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const getCountryList = async (): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.GetCountryList;
        const resp: any = await getPartApiInstance(endPoint);
        const response = resp?.length > 0 ? resp.map((country: any) => {
            return {
                ...country, value: country?.name, title: country?.name, selected: true
            }
        }) : []
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const getStateList = async (countryCode: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {

        const endPoint = SERVICEURI.GetStateList.replace('{countryCode}', countryCode);
        const resp: any = await getPartApiInstance(endPoint);
        const response = resp?.length > 0 ? resp.map((state: any) => {
            return {
                ...state, value: state?.name, title: state?.name
            }
        }) : [];
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const getPickupInfo = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data;
        const endPoint = SERVICEURI.GetPickupInfo?.replace("{cartid}", cartId)?.replace("{userAadId}", userAadId);
        const response = await getPartApiInstance(endPoint);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const getCreditCardList = (userAadId: any) => {
    let endPoint = SERVICEURI.GetCreditCardList?.replace("{userAadId}", userAadId);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getPaymentOption = (userAadId: any, cartId: any, isGuestUser: any) => {
    let endPoint = SERVICEURI.GetPaymentOption?.replace("{userAadId}", userAadId)?.replace("{cartId}", cartId).replace("{isGuest}", isGuestUser);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });

}

const getCreditCardUrl = () => {
    let endPoint = SERVICEURI.GetCreditCardUrl;
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });

}

const getCustomerCreditWarning = (userAadId: any, cartId: any) => {
    let endPoint = SERVICEURI.GetCustomerCreditWarning?.replace("{userAadId}", userAadId)?.replace("{cartId}", cartId);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getOrderSummaryDetails = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data;
        const endPoint = SERVICEURI.GetOrderSummaryDetails?.replace("{cartId}", cartId)?.replace("{userAadId}", userAadId);
        const response = await getPartApiInstance(endPoint);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const placeOrder = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.placeOrder;
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const getPaymentMethodList = async (userAadId: any, cartId: any, isGuestUser: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        let endPoint = SERVICEURI.GetPaymentOption?.replace("{userAadId}", userAadId)?.replace("{cartId}", cartId).replace("{isGuest}", isGuestUser);
        const response = await getPartApiInstance(endPoint);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    }
    catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const getPaymentInfo = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data;
        const endPoint = SERVICEURI.GetPaymentInfo?.replace("{userAadId}", userAadId)?.replace("{cartId}", cartId);
        const response = await getPartApiInstance(endPoint);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const getPunchOutScreenDistributorUrl = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data;
        let serviceUri = SERVICEURI.GetPunchOutScreenUrlDistributor;
        const endPoint = serviceUri?.replace("{userid}", userAadId)?.replace("{cartid}", cartId);
        const response = await postPartApiInstance(endPoint, {});
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const getPunchOutScreenCustomerUrl = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId, punchoutlogrequestid } = data;
        let serviceUri = SERVICEURI.GetPunchOutScreenUrlCustomer;
        const endPoint = serviceUri?.replace("{userid}", userAadId)?.replace("{cartid}", cartId)?.replace("{punchoutlogrequestid}", punchoutlogrequestid);;
        const response = await postPartApiInstance(endPoint, {});
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const clearCartCheckOutData = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data;
        const endPoint = SERVICEURI.ClearCartCheckOutData?.replace("{userAadId}", userAadId)?.replace("{cartId}", cartId);
        const response = await postPartApiInstance(endPoint, {});
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const checkPunchOutDistributor = async (distributorId: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.CheckPunchOutDistributor?.replace("{distributorId}", distributorId);
        const response = await postPartApiInstance(endPoint, {});
        return {
            isSuccess: true,
            msg: 'Success',
            data: response
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const getDelearBranchAvailability = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, partNumber, manufacturerCode, userAadId } = data;
        const endPoint = SERVICEURI.GetDelearBranchAvailability?.replace("{userAadId}", userAadId)?.replace("{cartId}", cartId)?.replace("{partNumber}", partNumber)?.replace("{manufacturerCode}", manufacturerCode);
        const response = await getPartApiInstance(endPoint);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const sendNotification = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.SendConfirmation.replace("{cartid}", data?.cartid);
        const response = await postPartApiInstance(endPoint, data);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const printOrderConfirmation = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId } = data;
        const endPoint = SERVICEURI.PrintOrderConfirmation?.replace("{cartId}", cartId)?.replace("{userAadId}", data?.userAadId);
        const response = await postPartApiInstance(endPoint, {});

        return {
            isSuccess: true,
            msg: 'Success',
            data: response
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const getOrderConfirmationDetails = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data;
        const endPoint = SERVICEURI.GetOrderConfirmationDetails?.replace("{cartId}", cartId).replace("{userAadId}", userAadId);
        const response = await getPartApiInstance(endPoint);

        return {
            isSuccess: true,
            msg: 'Success',
            data: response
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const shareOrderConfirmation = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data;
        const endPoint = SERVICEURI.ShareOrderConfirmation?.replace("{cartId}", cartId)?.replace("{userAadId}", userAadId);
        const response = await getPartApiInstance(endPoint);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const addForFuture = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const endPoint = SERVICEURI.AddForFuture;
        const response = await postPartApiInstance(endPoint, data);

        return {
            isSuccess: true,
            msg: 'Success',
            data: response
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: {}
        }
    }
}

const getConfirmationSummaryDetails = async (data: any): Promise<{ isSuccess: boolean; msg: any; data: any }> => {
    try {
        const { cartId, userAadId } = data;
        const endPoint = SERVICEURI.GetConfirmationSummaryDetails?.replace("{cartId}", cartId)?.replace("{userAadId}", userAadId);
        const response = await getPartApiInstance(endPoint);
        return {
            isSuccess: true,
            msg: 'Success',
            data: response ?? []
        };
    } catch (error) {
        return {
            isSuccess: false,
            msg: error,
            data: []
        }
    }
}

const calculateShippingCost = (data: any) => {
    const endPoint = SERVICEURI.CalculateShippingCost.replace("{cartId}", data?.cartId)?.replace("{shippingcharges}", data?.shippingCost);
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, {})
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const eventAuditLogForDownload = (data: any) => {
    const endPoint = SERVICEURI.EventAuditLogForDownload;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getPunchoutButtonVisibility = (data: any) => {
    const endPoint = SERVICEURI.GetPunchoutButtonVisibility;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getPunchoutHistory = (data: any) => {
    const endPoint = SERVICEURI.GetPunchoutHistory;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, data)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getPunchoutHistoryDetails = (model: any) => {
    const endPoint = SERVICEURI.GetPunchoutHistoryDetail;
    return new Promise((resolve, reject) => {
        postPartApiInstance(endPoint, model)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getCountryWithPhoneCodeList = async (filterText: any = "") =>
{
    let endPoint = SERVICEURI.GetCountryWithPhoneCodeList.replace("{filterText}", filterText);
    return new Promise((resolve, reject) => {
        getFrameworkApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getDropshipFlag = (distributorCode: string, branchCode: string): Promise<any> => {
    let endPoint = SERVICEURI.GetDropshipFlag?.replace("{distributorCode}", distributorCode)?.replace("{branchCode}", branchCode);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getPartsOrderingFlag = (customerId: any): Promise<any> => {
    let endPoint = SERVICEURI.GetPartsOrderingFlag?.replace("{customerId}", customerId);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getDropshipOtReturnableFlag = (distributorCode: string): Promise<any> => {
    let endPoint = SERVICEURI.GetDropshipOtReturnableFlag?.replace("{distributorCode}", distributorCode);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getGuestUserProfile = (anonymousId: string) => {
    let endPoint = SERVICEURI.GetGuestUserProfile.replace("{anonymousId}", anonymousId)
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getProductSuggestions = (searchTerm: any, distributorCode:any) => {
    let endPoint = SERVICEURI.GetProductSuggestions.replace("{searchTerm}", searchTerm)?.replace("{distributorcode}", distributorCode)
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getShowReturnableFlag = (data: any) => {
    const {Distributor4Code, DistributorBranch2Code} = data;
    let endPoint = SERVICEURI.GetShowReturnableFlag.replace("{Distributor4Code}", Distributor4Code).replace("{DistributorBranch2Code}", DistributorBranch2Code);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getMiningDistributorInfo = async (distributorCode: any) => {
    try {
        let endPoint = SERVICEURI.getMiningDistributorInfo.replace("{distributorCode}", distributorCode);
        const response = await getFrameworkApiInstance(endPoint);
        return response;
    } catch (error) {
        throw error;
    }
};
const getMiningPartsList = (userAddId: any): Promise<any> => {
    let endPoint = SERVICEURI.GetMiningPartsList?.replace("{userAadId}", userAddId);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });

};


const getKomatsuCreditHistory = (customerId: any, userId: any) => {
    const endPoint = SERVICEURI.GetKomatsuCreditHistory?.replace("{customerId}", customerId)?.replace("{userId}", userId);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

const getKomatsuCreditHistoryDetail = (customerId: any, creditEntryId: any) => {
    const endPoint = SERVICEURI.GetKomatsuCreditHistoryDetail?.replace("{customerId}", customerId)?.replace("{creditEntryId}", creditEntryId);
    return new Promise((resolve, reject) => {
        getPartApiInstance(endPoint)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}


export default
    {
        getBranchList, getManufactureList, addPartNumber, getPartsList, getRefreshPartsList, getMaintenancePartsList, updateCartItem,
        applyPromoCode,
        getItemSummaryDetails,
        deletePromoCode,
        applyPartsCredit,
        getAvailablePartsCredits,
        getCustomerCreditInfo,
        saveCartList,
        getQuotesDetailData,
        continuePartsCredit,
        saveCart,
        getFulfillmenPermissionDetails,
        getAvailabilityDetails,
        deletePartNumbers,
        addToCartQuote,
        getFullfilmentBranchInfo,
        getQuoteShareDetailData,
        savePickupFulfillment,
        uploadParts,
        getWeatherWarning,
        getShippingMethods,
        saveShipmentDetails,
        getSavedAddressList,
        getCountryList,
        getStateList,
        getPickupInfo,
        getProductRecommendationByCartId, getProductRecommendationByPartNumber, getBookmarkList, saveBookmark, removeBookmark, getSavedPartList, deleteItemFromPartList, exportToExcelSavedPartList,
        savePartListDataWithBookmarkItem, getSavedPartListDetails, getQuoteList, savePartListForQuote, deleteOrArchiveQuote, shareQuote, shareCart,
        getMachineListForShoppingCart,
        getPaymentOption,
        getCustomerCreditWarning,
        savePaymentDetails,
        getOrderSummaryDetails,
        getCreditCardList,
        getCreditCardUrl,
        placeOrder,
        saveCreditCard,
        getPaymentInfo,
        getPunchOutScreenDistributorUrl,
        getPunchOutScreenCustomerUrl,
        clearCartCheckOutData,
        checkPunchOutDistributor,
        getDelearBranchAvailability,
        sendNotification,
        printOrderConfirmation,
        getOrderConfirmationDetails,
        shareOrderConfirmation,
        addForFuture,
        getConfirmationSummaryDetails,
        calculateShippingCost,
        eventAuditLogForDownload,
        getPunchoutHistory,
        getPunchoutHistoryDetails,
        getPunchoutButtonVisibility,
        getCountryWithPhoneCodeList,
        getShippingCarriers,
        clearPartsCredit,
        getDropshipFlag,
        getGuestUserProfile,
        getShowReturnableFlag,
        getProductSuggestions,
        deleteMiningPartNumbers,
        getMiningDistributorInfo,
        getMiningPartsList,
        getPaymentMethodList,
        getPartsOrderingFlag,
        getDropshipOtReturnableFlag,
        getKomatsuCreditHistory,
        getKomatsuCreditHistoryDetail
    }